(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('NumReferenceContratDialogController', NumReferenceContratDialogController);

    NumReferenceContratDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'NumReferenceContrat', 'Agence'];

    function NumReferenceContratDialogController ($scope, $stateParams, $uibModalInstance, entity, NumReferenceContrat, Agence) {
        var vm = this;
        vm.numReferenceContrat = entity;
        vm.agences = Agence.query();
        vm.load = function(id) {
            NumReferenceContrat.get({id : id}, function(result) {
                vm.numReferenceContrat = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:numReferenceContratUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.numReferenceContrat.id !== null) {
                NumReferenceContrat.update(vm.numReferenceContrat, onSaveSuccess, onSaveError);
            } else {
                NumReferenceContrat.save(vm.numReferenceContrat, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
